import * as React from 'react';

/**
 * React Context for translation loader
 *
 * @type {React.Context}
 * @access private
 */

var LoaderContext = /*#__PURE__*/React.createContext();
/**
 * React Context for translation methods
 *
 * @type {React.Context}
 * @access private
 */

var TranslateContext = /*#__PURE__*/React.createContext();

export { LoaderContext, TranslateContext };
